import { Link } from 'react-router-dom'
import { MdOutlineRestaurant, MdOutlineCelebration } from "react-icons/md"

function ServicesCTA() {
    return (
        <section className="bg-[#1B4D3E] py-24 px-6">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                    <p className="text-orange-500 text-xs uppercase tracking-[0.3em] mb-4 font-semibold">
                        Let's Create Together
                    </p>
                    <h2 className="font-serif text-4xl md:text-6xl text-white mb-6 leading-tight">
                        Your Event, <span className="text-orange-500 italic">Our Expertise</span>
                    </h2>
                    <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                        From intimate gatherings to corporate functions, we handle every detail with precision
                        and care. Let's make your occasion unforgettable.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
                    <Link
                        to="/contact"
                        state={{ serviceType: 'catering' }}
                        className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1"
                    >
                        <div className="flex items-start justify-between mb-6">
                            <div className="bg-orange-500/20 p-4 rounded-xl">
                                <MdOutlineRestaurant className="h-8 w-8 text-orange-500" />
                            </div>
                            <span className="text-white/40 text-xs uppercase tracking-widest">Full Service</span>
                        </div>
                        <h3 className="font-serif text-2xl text-white mb-3 group-hover:text-orange-500 transition-colors">
                            Catering Services
                        </h3>
                        <p className="text-white/60 text-sm leading-relaxed mb-6">
                            From breakfast spreads to gala dinners, our culinary team crafts menus that
                            delight. Corporate lunches, private parties, or wedding receptions — we've got you covered.
                        </p>
                        <ul className="text-white/50 text-xs space-y-2 mb-6">
                            <li className="flex items-center gap-2">
                                <span className="text-orange-500">✓</span> Customized Menus
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="text-orange-500">✓</span> Professional Service Staff
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="text-orange-500">✓</span> Dietary Accommodations
                            </li>
                        </ul>
                        <div className="flex items-center text-orange-500 text-sm font-semibold uppercase tracking-widest group-hover:gap-3 transition-all">
                            Request Catering
                            <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </div>
                    </Link>

                    {/* Event Management Card */}
                    <Link
                        to="/contact"
                        state={{ serviceType: 'event-management' }}
                        className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1"
                    >
                        <div className="flex items-start justify-between mb-6">
                            <div className="bg-orange-500/20 p-4 rounded-xl">
                                <MdOutlineCelebration className="h-8 w-8 text-orange-500" />
                            </div>
                            <span className="text-white/40 text-xs uppercase tracking-widest">End-to-End</span>
                        </div>
                        <h3 className="font-serif text-2xl text-white mb-3 group-hover:text-orange-500 transition-colors">
                            Event Management
                        </h3>
                        <p className="text-white/60 text-sm leading-relaxed mb-6">
                            Complete venue management and coordination for weddings, corporate retreats,
                            and private celebrations. We handle logistics so you can enjoy the moment.
                        </p>
                        <ul className="text-white/50 text-xs space-y-2 mb-6">
                            <li className="flex items-center gap-2">
                                <span className="text-orange-500">✓</span> Venue Setup & Decor
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="text-orange-500">✓</span> Vendor Coordination
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="text-orange-500">✓</span> Day-of Management
                            </li>
                        </ul>
                        <div className="flex items-center text-orange-500 text-sm font-semibold uppercase tracking-widest group-hover:gap-3 transition-all">
                            Plan Event
                            <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </div>
                    </Link>

                </div>
                
                <div className="mt-12 text-center">
                    <p className="text-white/60 text-sm mb-2">
                        Ready to discuss your event?
                    </p>
                    <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-white/80 text-sm">
                        <a href="tel:+254711610000" className="hover:text-orange-500 transition-colors flex items-center gap-2">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                            </svg>
                            +254 711 610 000
                        </a>
                        <span className="text-white/30 hidden md:block">|</span>
                        <a href="mailto:sagefurnishedapartments@gmail.com" className="hover:text-orange-500 transition-colors flex items-center gap-2">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            sagefurnishedapartments@gmail.com
                        </a>
                    </div>
                    <p className="text-white/40 text-xs mt-6 tracking-wide">
                        ✓ Based in Kisumu &nbsp;•&nbsp; ✓ Serving All Occasions &nbsp;•&nbsp; ✓ Competitive Packages
                    </p>
                </div>
            </div>
        </section>
    )
}

export default ServicesCTA